import loadable from '@wix/yoshi-flow-editor/loadable';
import type {LoadedLayoutProps} from './LoadedLayout';

type LoadedLayoutLazyProps = LoadedLayoutProps & {fallback?: React.JSX.Element};

const LoadedLayoutLazyComp = loadable(
  () =>
    import(
      /* webpackChunkName: "CheckoutLoadedLayout" */
      './LoadedLayout'
    ),
  {
    resolveComponent: (components) => components.LoadedLayout,
  }
);
/* istanbul ignore next */
if (typeof window !== 'undefined') {
  LoadedLayoutLazyComp.preload();
}

export const LoadedLayoutLazy = LoadedLayoutLazyComp as React.ComponentType<LoadedLayoutLazyProps>;
